import mutations from './mutations';

const BaseData = {
    namespaced: true,
    state: {
        app_name: 'App Name ......',
        company_name: 'APP...',
        tag_line_one: '...',
        tag_line_two: '...',
        address: '...',
        description: '...',
        email: 'arindy@project.com',
        phone: '082211122370',
        fax: '031-999-777',
        website: 'https://github.com/arindyproject/',
        instagram: 'https://www.instagram.com/devarindy/',
        youtube: 'https://www.youtube.com/@arindyproject',
        main_icon: 'https://avatars.githubusercontent.com/u/31184693?v=4',
        second_icon: 'https://avatars.githubusercontent.com/u/31184693?v=4',
        img_background: '',
        main_theme_color: '#1175D3',
        second_theme_color: '#E9374C',
        version: '1.0.0',
    },
    mutations
};

export default BaseData;
